import { useWebsiteBanner } from '@shared/components/WebsiteBanner';
import { useTranslation } from '@shared/core';

interface UseHeaderLayoutUpgradeBannerArgs
  extends Readonly<{
    isVisible: boolean;
    onUpgrade: () => void;
    onClose?: () => void;
  }> {}

/**
 * Registers the header layout upgrade banner.
 * Shows when website is published without video background.
 */
export const useHeaderLayoutUpgradeBanner = (args: UseHeaderLayoutUpgradeBannerArgs) => {
  const { isVisible, onUpgrade, onClose } = args;
  const { tq } = useTranslation('headerLayoutUpgrade');

  useWebsiteBanner({
    id: 'header-layout-upgrade',
    isVisible,
    message: {
      default: tq`Your website is published without the video background`,
    },
    actionButton: {
      label: {
        default: tq`Upgrade Now`,
      },
      onClick: onUpgrade,
    },
    onClose,
  });
};
